import { render } from "./Footer.vue?vue&type=template&id=1b9c1ad1&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=1b9c1ad1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9c1ad1"]])

export default __exports__